<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    bottom
    left
    max-width="90%"
    min-width="275"
    offset-x
    offset-y
    origin="top right"
    transition="scale-transition"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-card
        id="settings"
        class="py-2 px-4"
        color="#0000004D"
        dark
        flat
        style="position: fixed; top: 164px; right: -35px;"
        width="100"
        v-bind="attrs"
        v-on="on"
      >
        <v-badge
          :content="itemsInCart"
          :value="itemsInCart"
          color="green"
          overlap
        >
          <v-icon large>
            mdi-cart
          </v-icon>
        </v-badge>
      </v-card>
    </template>

    <v-card class="py-2">
      <base-title
        align="center"
        title="Warenkorb"
        space="0"
      />

      <v-card-text
        v-if="cart.items"
      >
        <v-list
          class="transparent"
        >
          <v-list-item
            v-for="item in cart.items"
            :key="item.id"
          >
            <v-list-item-icon>
              <v-img
                class="white--text align-end"
                :src="item.product.base_image.medium_image_url"
                max-width="30px"
              />
            </v-list-item-icon>
            <v-list-item-content>
              <v-row>
                <v-col>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>

                  <v-list-item-subtitle>
                    {{ item.quantity }} Stück á {{ item.formated_price }}
                  </v-list-item-subtitle>
                </v-col>
                <v-col>
                  <v-icon
                    right
                    @click="$store.dispatch('removeFromCard', item.id)"
                  >
                    mdi-minus-circle
                  </v-icon>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider class="my-2" />
        <div>
          Summe: {{ cart.formated_grand_total }}
        </div>
        <v-divider class="my-2" />

        <div class="text-center">
          <base-btn
            :tile="false"
            @click="$store.commit('showCheckout')"
          >
            <v-icon left>
              mdi-cash
            </v-icon>
            Zur Kassa
          </base-btn>
        </div>
      </v-card-text>
      <v-card-title v-else>
        Keine Produkte im Warenkorb
      </v-card-title>
    </v-card>
  </v-menu>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'Cart',

    data () {
      return {
        cartData: {},
        menu: false,
      }
    },
    computed: {
      ...mapGetters([
        'cart',
        'itemsInCart',
      ]),
    },
    mounted () {
      this.getCartData()
    },
    methods: {
      getCartData () {
        this.$store.dispatch('getCartData')
      },
    },
  }
</script>
